import React, { Component } from 'react';
import 'whatwg-fetch'; 
class getTimerFijo extends Component {

//componentDidMount
 componentWillUnmount () {
   clearInterval(this.timer)
 }

 validar =()=>{
   const url= this.props.dir_url + "webapp/getGlobalNotificaciones";
   const token =  this.props.token
   const token_Client = this.props.token_Client
   var obj = { accion:'globalnotificaciones', token, token_Client};
   fetch(url, {
     method: 'POST',
     body: JSON.stringify(obj),
     headers:{
       'Accept':'application/json',
       'Content-Type': 'application/json'
     }
   })
   .then(res => res.json())
   .then((data) => {
     if(data[0].status==="ok"){
       if(data[0].msg==="reiniciar"){
         if(localStorage.codigo_reinicio===data[0].codigo){
         }else{
           localStorage.codigo_reinicio=data[0].codigo
           window.location.reload(false)
           console.log("Reinicio")
         }
       }
       if(data[0].msg==="notificación_imagen"){
         if(localStorage.codigo_imagen===data[0].codigo){
         }else{
           localStorage.codigo_imagen=data[0].codigo
           this.props.get_new_notificacion("notificacion_global",data[0].dir_url)
           console.log("Notificación")
         }
       }
     }

     console.log("Validación Global")
   })
   .catch(console.log)
 }
 tick () {
   this.validar()
 }
 startTimer () {
   clearInterval(this.timer)
   this.timer = setInterval(this.tick.bind(this), 600000)//600000
 }
 stopTimer () {
   clearInterval(this.timer)
 }
 render () {
   return (
     <React.Fragment>
     </React.Fragment>
   )
 }
 componentDidMount (){
   this.startTimer()
   this.validar()
 }
}
export default getTimerFijo;
